import jQuery from 'jquery';

var datePickerDesignSelectModule = (function () {
	jQuery.datepicker._updateDatepicker_original = jQuery.datepicker._updateDatepicker;
	jQuery.datepicker._updateDatepicker = function (inst) {
		jQuery.datepicker._updateDatepicker_original(inst);
		var afterShow = this._get(inst, 'afterShow');
		if (afterShow) {
			afterShow.apply(inst.input ? inst.input[0] : null, [inst]);
		}
	};
	function datepickerDesignSelect(elem, cb) {
		// Fallback case, if there is no element parameter, use the default selector to find datepickers.
		if (!elem) elem = '.datepicker';

		var options = {
			onSelect: cb,
			changeMonth: false,
			changeYear: false,
			showOn: 'both',
			buttonImageOnly: true,
			/* buttonImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGhSURBVHgB7ZdNTsJAFIDfK9XgysYN7Bw4AZxA3LlQwg3EE6gnEG/gDeQIxJ/Enb0B8QIwruyyxo0myvNNobElJVMNgyWZL2k6MzyYr+1MeQ9gnfFEy1OHqXgF5g30RMcr49dQtd/prRlKP1xmfIwDOSnzHHwS6tjCne1lx/9aaFUUTihzDVXFgQBn8xiARCLQI4KOahPCgPuh5ocXx0/oGeCzH8gHmfG9NJV6+xSJrmAVIPaC0c1laijZie4MboxVm/iKkK8MTEDQgumC5zbtB/LOjz9yIWXnntG0KT+o1AzHg1xb9S9Uau0hAjV4PvVY/Xg8tahpulWVmR9KczLRFDR5is4Opl4JhdtlbuYoP+Nq/egaTEKwB7mF1IIj6MI/sEhIqnUEJknutATZQiwTjG5PwCBVcdjn95CYH7f/ZTqskA4rpMMK6bBCOqyQjmILxaUKVx0NMEhU7yNGCRpN6HXO4QdOCVoc+DjrGsuJVL2Gcf5OpVogBzJTaCbVY6kLWAGc6J+/yPtUDbigcu0Iriy74OAumCCqXN1+8s5Y1pZv3dh+vp39yoAAAAAASUVORK5CYII=', */
			buttonImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEcSURBVHgB7ZXNUcMwEIXfbnwnJYgKcAcMFeACYn6dM1w5EELcBiRhkgNXKoAO4qEBTAdpAC3rgIkdMjAjwTBk8p0kPWvfejUrAX/JXjs9iZPeqatewF+JIogEtOuqf2vwE1B10jruRsSNfQiabysSvn+WLd++RLdyM+p3hp8M4qPuAZgHGjwXohwu2YoYjWhgcViaBB/qLHPJR9edTXjQStIJsY10OJyFrYqumVfRkkwFvFHOg7ooYZyk9/CiOJf5mQR1rfgLeLG4vWagJcrGV+c78GCxAr/eB2uDtcG/MhBM9a5twhfSG7XCvJPl5Y6IB3G796QtncMpthh95QxZuSzXGuXgcfKQbYXbz0Js4IiwJib2bNy/uMXK8ArSil8GbXowWwAAAABJRU5ErkJggg==',
			
			buttonText: 'Naptár', // this is the alt and title text
			showOtherMonths: true,
			selectOtherMonths: true,
			afterShow: function (inst) {
				window.designSelect(jQuery('.ui-datepicker-year, .ui-datepicker-month'));
			}
		};

		if (elem.getAttribute('data-min-date')) {
			options.minDate = new Date(elem.getAttribute('data-min-date'));
		}

		if (elem.getAttribute('data-max-date')) {
			options.maxDate = new Date(elem.getAttribute('data-max-date'));
		}

		jQuery(elem).datepicker(options);
	}

	window.datepickerDesignSelect = datepickerDesignSelect;
	return {
		datepickerDesignSelect: datepickerDesignSelect
	};
}());
